<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">{{ $t('menu.orderCenter') }}</span>
      </div>
      <div class="title-right">
        <el-button type="primary" class="button-v2" @click="handleAdd" v-if="!isReadOnly">+ {{ $t('createOrder') }}</el-button>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          align="center"
          :columns="columns"
          :data="tableData"
          @change-filter="changeFilter"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="toDetail(row)">{{ $t('viewDetails') }}</span>
            <div v-if="row.orderCode === '待接单' && !isReadOnly" class="divider ml10 mr10"></div>
            <span v-if="row.orderCode === '待接单' && !isReadOnly" class="text-button" @click="handleDelete(row)">{{ $t('handleDelete') }}</span>
          </div>
        </template>
      </air-table>
      <bsp-pagination :pager-config.sync="queryParams" @page-change="getData"></bsp-pagination>
    </div>

    <el-dialog class="modal-v2" :title="modal.title" :visible.sync="modal.show" :close-on-click-modal="false" width="700px" append-to-body>
      <template v-if="addSuccess">
        <div class="flex vertical center">
          <img src="@/assets/img/v2/common/success.png" class="size50 mt34" />
          <span class="font-16 fw-500 color-0 mt22">恭喜您！您的订单 {{ form.orderId }} 创建成功</span>
          <div class="wage-month-bg flex center mt33">
            <div class="flex acenter">
              <span class="font-14 fw-500 color-0">工资月份：</span>
              <span class="font-14 color-3">{{ $day(form.wageMonth).format('YYYY年M月') }}</span>
            </div>
            <div v-if="form.payTime" class="flex acenter ml50">
              <span class="font-14 fw-500 color-0">发薪日期：</span>
              <span class="font-14 color-3">{{ $day(form.payTime).format('YYYY年M月D日') }}</span>
            </div>
          </div>
          <span class="font-12 color-9 mt30 mb30" v-if="isEn">{{$t('turnOff')}}{{ addSuccessCountdown }}{{$t('seconds')}}</span>
          <span class="font-12 color-9 mt30 mb30" v-else>{{ addSuccessCountdown }}{{$t('seconds')}}后自动关闭</span>
        </div>
        <div slot="footer" class="w100 flex jend acenter">
          <el-button type="primary" class="button-v2" @click="modal.show = false">确定</el-button>
        </div>
      </template>
      <template v-else>
        <div class="flex vertical">
          <el-form ref="form" class="form-v2 report-form" :model="form" :rules="formRules" :label-width="isEn ? '140px' : '120px'" style="margin: 40px 0; padding: 0 50px;" size="small" label-suffix="：">
            <el-form-item class="fixed-height" :label="$t('wageMonth')" prop="wageMonth">
              <div class="date-picker-v2 w100">
                <el-date-picker v-model="form.wageMonth" type="month" format="yyyy-MM" value-format="yyyy-MM" :placeholder="$t('selectYearMonth')" prefix-icon="none" :clearable="false"></el-date-picker>
                <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
              </div>
            </el-form-item>
            <el-form-item class="fixed-height" :label="$t('payDate')" prop="payTime">
              <div class="date-picker-v2 w100">
                <el-date-picker v-model="form.payTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :placeholder="$t('selectDate')" prefix-icon="none" :clearable="false" :picker-options="payTimeOptions"></el-date-picker>
                <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
              </div>
            </el-form-item>
            <el-form-item :label="$t('remarks')" prop="remark">
              <el-input type="textarea" class="textarea-v2" v-model="form.remark" :placeholder="$t('inputPlaceholder')" maxlength="2000" :rows="4" />
            </el-form-item>
            <el-form-item :label="$t('informationAttachments')" prop="remark">
              <air-upload-file :file-list="fileList" @change="handleUploadFile"></air-upload-file>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="w100 flex jbetween acenter">
          <el-button plain class="button-v2" @click="modal.show = false">{{ $t('cancel') }}</el-button>
          <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">{{ $t('save') }}</el-button>
        </div>
      </template>
    </el-dialog>

    <air-confirm-v2
        :show.sync="confirmShow"
        :title="confirmTitle"
        :content="confirmContent"
        :confirm-function="confirmFunction"
    ></air-confirm-v2>
  </div>
</template>

<script>
import * as api from '@/api/v2/service-process/order'
import { processTextList } from './config'
import { mapGetters } from 'vuex';

export default {
  name: 'ServiceProcessOrder',
  components: {},
  data() {
    let orderCodeOptions = []
    for (let item of processTextList) {
      orderCodeOptions.push({
        codeItemId: item,
        codeItemName: item
      })
    }
    // 发薪日期不能早于工资月份
    const checkPayTime = (rule, value, callback) => {
      if (this.form.wageMonth && this.form.payTime && this.$day(this.form.payTime).isBefore(this.form.wageMonth)) {
        callback(new Error(this.$t('validateWageMonth')))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      queryParams: {
        page: 1,
        limit: 20,
        total: 0
      },
      columns: [
        {title: '工资月份', itemEnName: 'Wage month', field: 'wageMonth', minWidth: 100, filterType: 'month'},
        {title: '订单编号', itemEnName: 'Order number', field: 'orderId', minWidth: 150, filterType: 'input'},
        {title: '订单状态', itemEnName: 'Order status', field: 'orderCode', minWidth: 80, filterType: 'select', filterOptions: orderCodeOptions},
        {title: '创建时间', itemEnName: 'Create time', field: 'createTime', minWidth: 120, filterType: 'daterange'},
        {title: '服务人员', itemEnName: 'Service staff', field: 'ciicUserName', minWidth: 100, filterType: 'input'},
        {title: '应发工资合计', itemEnName: 'Total wages payable', field: 'payAmountTotal', money: true, minWidth: 100},
        {title: '实发工资合计', itemEnName: 'Total paid wages', field: 'actPayAmountTotal', money: true, minWidth: 100}
      ],
      tableData: [],
      form: {},
      formRules: {
        wageMonth: [{ required: true, message: this.$t('selectYearMonth'), trigger: 'change' }],
        payTime: [{ validator: checkPayTime, trigger: 'blur' }],
      },
      payTimeOptions: {
        disabledDate: (time) => {
          if (this.form.wageMonth) return time.getTime() < new Date(this.form.wageMonth).getTime() - 24 * 60 * 60 * 1000
        }
      },
      fileList: [],
      modal: {
        show: false,
        title: this.$t('createOrder')
      },
      addSuccess: false,
      addSuccessCountdown: 0,
      submitLoading: false,
      confirmShow: false,
      confirmTitle: '',
      confirmContent: '',
      confirmFunction: undefined,
      paidModalShow: false
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'isReadOnly']),
    isEn() {
      return localStorage.getItem('lang') == 'en';
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.queryParams.cusId = this.$userInfo.cusId
      this.getData()
    },
    getData() {
      this.loading = true
      api.selectOrder(this.queryParams).then(res => {
        this.tableData = res.data.data.records
        this.queryParams.total = res.data.data.total
        this.loading = false
      })
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      if (this.queryParams.createTime) {
        this.queryParams.createBeginTime = this.queryParams.createTime[0]
        this.queryParams.createEndTime = this.queryParams.createTime[1]
      }
      this.getData()
    },
    reset() {
      this.form = {
        wageMonth: undefined,
        payTime: undefined,
        remark: undefined,
        attrs: [],
        cusId: this.$userInfo.cusId
      }
      this.fileList = []
      this.addSuccess = false
    },
    handleUploadFile({ fileList }) {
      this.fileList = fileList
    },
    handleAdd() {
      this.reset()
      this.modal.title = this.$t('createOrder')
      this.$nextTick(() => {
        this.modal.show = true
      })
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.form.attrs = this.fileList.map(item => {
            return {
              fileId: item.fileId
            }
          })
          api.addorder(this.form).then(res => {
            if (res.data.code === 0) {
              this.getData()
              this.form.orderId = res.data.data.orderId
              this.addSuccess = true
              this.addSuccessCountdown = 10
              let timerId = setInterval(() => {
                this.addSuccessCountdown--
                if (this.addSuccessCountdown <= 0) {
                  clearInterval(timerId)
                  this.modal.show = false
                }
              }, 1000)
            }
          }).finally(() => this.submitLoading = false)
        }
      })
    },
    toDetail(item) {
      this.$go('/v2/service-process/order/detail', {
        wageMonth: item.wageMonth,
        orderId: item.orderId
      })
    },
    handleDelete(item) {
      this.confirmShow = true
      this.confirmTitle = this.$t('deleteOrder');
      this.confirmContent = `${ this.$t('confirmDeleteTip') }「${item.orderId}」?`
      this.confirmFunction = () => {
        api.deleteOrder({ orderId: item.orderId }).then(() => {
          this.getData()
          this.$msgSuccess(this.$t('deleteSuccessfully'))
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.wage-month-bg {
  width: 649px;
  height: 60px;
  background: #F8F9FA;
  border-radius: 4px;
}
</style>
